import { CellAction } from "./cell-action";

import { ColumnDef } from "@tanstack/react-table";
import { showDate } from "../../../lib/dateFormater";

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "title",
    header: "TITRE",
  },
  {
    accessorKey: "category",
    header: "CATÉGORIE",
  },

  {
    accessorKey: "date",
    header: "DATE",
    cell: ({ row }) => {
      return showDate(row.original.createdAt);
    },
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
